<template>
    <div class="inner">
        <!-- Header -->
        <div class="header white">
            <span>The Speakers</span>
        </div>
        <div class="speakers">
            <div class="speaker">
                <img src="../../../public/assets/images/s.png" alt="speaker">
                <div class="title">Karim Awad</div>
                <div class="description">Group CEO and Chairman of the Executive Committee, EFG Holding
                </div>
            </div>
            <div class="speaker">
                <img src="../../../public/assets/images/s.png" alt="speaker">
                <div class="title">Karim Awad</div>
                <div class="description">Group CEO and Chairman of the Executive Committee, EFG Holding
                </div>
            </div>
            <div class="speaker">
                <img src="../../../public/assets/images/s.png" alt="speaker">
                <div class="title">Karim Awad</div>
                <div class="description">Group CEO and Chairman of the Executive Committee, EFG Holding
                </div>
            </div>
            <div class="speaker">
                <img src="../../../public/assets/images/s.png" alt="speaker">
                <div class="title">Karim Awad</div>
                <div class="description">Group CEO and Chairman of the Executive Committee, EFG Holding
                </div>
            </div>
            <div class="speaker">
                <img src="../../../public/assets/images/s.png" alt="speaker">
                <div class="title">Karim Awad</div>
                <div class="description">Group CEO and Chairman of the Executive Committee, EFG Holding
                </div>
            </div>
            <div class="speaker">
                <img src="../../../public/assets/images/s.png" alt="speaker">
                <div class="title">Karim Awad</div>
                <div class="description">Group CEO and Chairman of the Executive Committee, EFG Holding
                </div>
            </div>
            <div class="speaker">
                <img src="../../../public/assets/images/s.png" alt="speaker">
                <div class="title">Karim Awad</div>
                <div class="description">Group CEO and Chairman of the Executive Committee, EFG Holding
                </div>
            </div>
            <div class="speaker">
                <img src="../../../public/assets/images/s.png" alt="speaker">
                <div class="title">Karim Awad</div>
                <div class="description">Group CEO and Chairman of the Executive Committee, EFG Holding
                </div>
            </div>
            <div class="speaker">
                <img src="../../../public/assets/images/s.png" alt="speaker">
                <div class="title">Karim Awad</div>
                <div class="description">Group CEO and Chairman of the Executive Committee, EFG Holding
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style></style>